import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

export const RecallUnitLevel = ({ ...props }) => {
  const [ t ] = useTranslation();

  const options = [
    { text: t('fields.unitLevel.gtinBased'), value: '1' },
    { text: t('fields.unitLevel.batchBased'), value: '2' },
    { text: t('fields.unitLevel.unitBased'), value: '3' }
  ];


  return (
    <LabeledSelect
      { ...props }
      options={ options }
    />
  );
};
